import { render, staticRenderFns } from "./forex-search.vue?vue&type=template&id=02a493fa&scoped=true"
import script from "./forex-search.vue?vue&type=script&lang=js"
export * from "./forex-search.vue?vue&type=script&lang=js"
import style0 from "./forex-search.vue?vue&type=style&index=0&id=02a493fa&prod&lang=css"
import style1 from "./forex-search.vue?vue&type=style&index=1&id=02a493fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a493fa",
  null
  
)

export default component.exports